import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    FlartChangeNrStatus: 'idle',
    FlartChangeNrError: undefined as any,

    flartChangeNrList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const FlartChangeNr = createAsyncThunk('flartChangeNrSlice/FlartChangeNr', async ({ flartChangeNr }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/FlartMenu_ChangeNr/`,
        prepareData(flartChangeNr),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { FlartChangeNrStatus } = getState().flartChangeNrSlice
        return FlartChangeNrStatus !== 'pending'
    }
})

const FlartChangeNrSlice = createSlice({
    name: 'flartChangeNrSlice',
    initialState,
    reducers: {
        resetFlartChangeNrError: (state) => {
            state.FlartChangeNrError = undefined
        },
        removeFromFlartChangeNrListById: (state, action) => {
            state.flartChangeNrList = state.flartChangeNrList.filter((x: any) => x.None !== action.payload)
        },
        removeFromFlartChangeNrListByIds: (state, action) => {
            state.flartChangeNrList = state.flartChangeNrList.filter((x: any) => action.payload.indexOf(x.None) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flartChangeNrList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.FlartChangeNrStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flartChangeNrList = []
            state.FlartChangeNrStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(FlartChangeNr.pending, (state) => {
            state.FlartChangeNrStatus = 'pending'
            state.FlartChangeNrError = undefined
        })
        builder.addCase(FlartChangeNr.fulfilled, (state, action) => {
            state.FlartChangeNrStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flartChangeNrList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flartChangeNrList.push(newItem) }
                else { state.flartChangeNrList[i] = { ...state.flartChangeNrList[i], ...newItem } }
            }
        })
        builder.addCase(FlartChangeNr.rejected, (state, action) => {
            state.FlartChangeNrStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.FlartChangeNrError = action.error.message
            } else {
                state.FlartChangeNrError = action.payload
            }
        })

    }
})

export const {
    resetFlartChangeNrError,
    removeFromFlartChangeNrListById,
    removeFromFlartChangeNrListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlartChangeNrSlice.actions
export default FlartChangeNrSlice.reducer
